<template>
  <dashboard-layout>
    <template #content>
      <router-view />
    </template>
  </dashboard-layout>
</template>

<script>
export default {

  name: 'Opportunities',

  components: {
    DashboardLayout: () => import('../../layouts/DashboardLayout.vue'),
  },

};
</script>

<style lang="css" scoped>
</style>
